import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PartnerBoxAds } from "@/components/Sections/Price/BuyView/PartnerBoxAds";
import { Section, Title } from "@/components/UI";
import { useRefsContext } from "@/contexts/ref";
import { useBrandContext } from "@/shared/contexts";
import { PARTNER_NAME } from "@/shared/types";
import { Box } from "@gemini/core";
import { useI18n } from "@/shared/hooks";
import { AlternatePriceTotalCost } from "@/components/Sections/Price/PriceTotalCost/AlternatePriceTotalCost";
import { PriceUnit } from "@/components/Sections/Price/BuyView/PriceUnit";
import { usePriceComponents } from "@/components/Sections/Price/hooks/usePriceComponents";
import { TotalCostInfoMessage } from "@/components/Sections/Price/PriceTotalCost/TotalCostInfoMessage";
import { MortgagePriceLink } from "@/shared/components/MortgagePriceLink/MortgagePriceLink";
export const priceTestId = "cdp-price";
export const AlternatePrice = () => {
    var _a, _b;
    const { priceRef } = useRefsContext();
    const modalPartner = useBrandContext().partnerService.find((service) => service.name === PARTNER_NAME.KFW);
    const { t } = useI18n();
    // we skip the first component as it's already displayed in the new TotalCost component
    const components = (_b = (_a = usePriceComponents()) === null || _a === void 0 ? void 0 : _a.slice(1)) !== null && _b !== void 0 ? _b : [];
    const boxStyleProps = {
        borderRadius: "radius.16",
        borderColor: "color.border.light.default",
        borderStyle: "solid",
        borderWidth: "borderWidth.1",
        paddingTop: "spacing.16",
    };
    return (_jsxs(Section, { ref: priceRef, hasDivider: true, testId: priceTestId, children: [_jsx(Title, { variant: "section", title: t("price.title_buy"), id: "price" }), _jsx(TotalCostInfoMessage, {}), _jsxs(Box, { display: "grid", gridTemplateColumns: {
                    "breakpoint.base": "repeat(1, 1fr)",
                    "breakpoint.md": "repeat(2, 1fr)",
                }, gap: "spacing.16", children: [_jsxs(Box, { display: "grid", gridColumn: {
                            "breakpoint.base": "1/1",
                            "breakpoint.md": "1/2",
                        }, gap: "spacing.16", children: [_jsx(AlternatePriceTotalCost, {}), _jsx(MortgagePriceLink, { variant: "buttonStyled" }), _jsx(PartnerBoxAds, { partner: modalPartner })] }), _jsx(Box, { gridColumn: {
                            "breakpoint.base": "1/1",
                            "breakpoint.md": "2/2",
                        }, children: components.map(({ key, units }, index) => (_jsx(Box, Object.assign({ paddingBottom: "spacing.8", marginTop: index > 0 ? "spacing.32" : "spacing.none" }, boxStyleProps, { children: units.map((unit) => (_jsx(Box, { children: _jsx(PriceUnit, { unit: unit, componentType: "SECONDARY", hideLabel: true }) }, unit.key))) }), key))) })] })] }));
};
